import React from "react";

function useOutsideClick(
  originatorRef: React.RefObject<HTMLElement>,
  refs: React.RefObject<HTMLElement>[],
  handler: (event: MouseEvent | TouchEvent) => void,
) {
  React.useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!event.target) return;
      if (!originatorRef.current) return;
      const target = event.target as Node;
      const root = window.document.getElementById("root") || window.document.body;
      if (!root) {
        if (process.env["NODE_ENV"] === "test") {
          handler(event);
          return;
        }

        throw new Error("Missing root");
      }
      if (refs.map(ref => ref.current).some(element => !element || element.contains(target)))
        return;

      const sourceOnRoot = root.contains(originatorRef.current);
      if (sourceOnRoot && !root.contains(target)) return; // opened menu is on main app but click is on portal (modal)
      if (!sourceOnRoot && root.contains(target)) return; // opened menu is on portal (modal) but click is on root?

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener, { passive: true });

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [handler, originatorRef, refs]);
}

export default useOutsideClick;
